import React from "react";
import styled from "styled-components";

const StyledBox = styled.div`
  margin: 1rem 0 4rem;
`;

interface IFormSectionProps {
  children: React.ReactNode;
}

const FormSection = (props: IFormSectionProps) => {
  const { children } = props;
  return <StyledBox>{children}</StyledBox>;
};

export default FormSection;
